import { type LinearConfiguration } from "../../Linear/models";
import { type LinearConfiguratorState } from "../../Linear/redux/types";
import { type CsticUpdate } from "../../Linear/api/sendLinearConfiguratorUpdate";
import { prepareCommonCarriageData, sendCarriage } from "./sendCarriageCommon";
import { prepareApiDataForUpdate } from "../../common/commonConfiguratorApi";
import { getMainKmat } from "~/Configurators/Shaft/common/commonShaftHelpers";
import { FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE } from "../carriageConfiguratorConstants";
import { ConfiguratorType } from "~/Configurators/ConfiguratorType";
import { transform } from "~/Configurators/Linear/linearDataTransformer";
import { isNonNull } from "~/utils/reducers";

export async function sendCarriageUpdate(
  linearState: LinearConfiguratorState,
  updatedCstics: CsticUpdate[],
): Promise<LinearConfiguration> {
  const data = prepareCommonCarriageData(linearState);

  const updateData = prepareApiDataForUpdate(linearState, updatedCstics);

  const response = await sendCarriage({
    ...data,
    ...updateData,
  });

  const oldCstics = getMainKmat({ kmats: linearState.kmats }).cstics;
  const csticsToPreserve = [FAKE_CSTIC_LUBRICATION_CONNECTOR_TYPE].map((name) => oldCstics[name]).filter(isNonNull);

  return transform(response, ConfiguratorType.Carriage, csticsToPreserve);
}
